export interface CsvPreview {
  header: string[];
  rows: string[][];
  truncated: boolean;
}

/**
 * Small RFC-4180-ish CSV parser used ONLY for the client-side preview of the
 * import wizard (first N rows for the column-mapping step). The actual import
 * streams the raw file to the server, which re-parses and re-validates every
 * cell — this preview is a convenience, never the trust boundary.
 */
export function parseCsvPreview(text: string, maxRows = 100): CsvPreview {
  const records: string[][] = [];
  let field = "";
  let record: string[] = [];
  let inQuotes = false;
  let truncated = false;

  const pushField = () => {
    record.push(field);
    field = "";
  };
  const pushRecord = () => {
    pushField();
    // skip records that are entirely empty (e.g. trailing newline)
    if (record.length > 1 || record[0] !== "") {
      records.push(record);
    }
    record = [];
  };

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
    } else if (ch === '"' && field === "") {
      inQuotes = true;
    } else if (ch === ",") {
      pushField();
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && text[i + 1] === "\n") i++;
      pushRecord();
      if (records.length > maxRows) {
        truncated = true;
        break;
      }
    } else {
      field += ch;
    }
  }
  if (!truncated && (field !== "" || record.length > 0)) {
    pushRecord();
  }

  const header = records.length > 0 ? records[0] : [];
  const rows = records.slice(1, maxRows + 1);
  return { header, rows, truncated: truncated || records.length - 1 > maxRows };
}
